import React from "react";
import { Card, Empty, Ring, pct } from "./TvBits";

const Movers = ({ d }) => {
  const rows = [...(d.gainers || []).slice(0, 3), ...(d.losers || []).slice(0, 2)];
  const max = Math.max(1, ...rows.map((m) => Math.abs(m.change_pct || 0)));
  return (
    <div className="space-y-3">
      {rows.map((m, i) => {
        const up = (m.change_pct || 0) >= 0, col = up ? "#10B981" : "#F43F5E";
        return (
          <div key={m.ticker} className="flex items-center gap-3">
            <b className="text-cyan-50 font-mono text-2xl w-24 shrink-0">{m.ticker}</b>
            <div className="flex-1 h-4 rounded-full bg-white/5 overflow-hidden">
              <div className="h-full rounded-full nx-grow-x nx-glowbar" style={{ width: `${(Math.abs(m.change_pct) / max) * 100}%`, background: col, "--glow": col, animationDelay: `${i * 0.1}s` }} />
            </div>
            <b className="text-2xl w-28 text-right" style={{ color: col }}>{pct(m.change_pct)}</b>
          </div>
        );
      })}
    </div>
  );
};

export const TvMission = ({ d }) => {
  const fcol = d.fng ? (d.fng.value >= 55 ? "#10B981" : d.fng.value <= 45 ? "#EF4444" : "#F59E0B") : "#00F0FF";
  return (
    <div className="grid grid-cols-5 grid-rows-[1fr_auto] gap-5 h-full" data-testid="tv-scene-mission">
      <Card title="NEXUS BRIEF" code="AI·LIVE" className="col-span-3 row-span-2" testid="tv-brief">
        <div className="space-y-[clamp(0.75rem,1.4vh,1.5rem)]">
          {(d.brief || []).slice(0, 4).map((b, i) => (
            <div key={i} className="flex gap-4 nx-fade-up" style={{ animationDelay: `${i * 0.15}s` }}>
              <span className="nx-orbitron text-2xl font-black w-12 h-12 shrink-0 rounded-xl flex items-center justify-center border border-cyan-300/40 text-cyan-300" style={{ boxShadow: "0 0 14px #00F0FF33" }}>{String(i + 1).padStart(2, "0")}</span>
              <p className="text-[clamp(0.95rem,1.45vw,1.85rem)] leading-snug font-semibold text-cyan-50 line-clamp-2">{b}</p>
            </div>
          ))}
          {!(d.brief || []).length && <Empty>Nexus is writing your brief…</Empty>}
        </div>
      </Card>
      <Card title="RADAR" code="MOVERS" accent="#F59E0B" className="col-span-2" testid="tv-radar">
        <Movers d={d} />
        {(d.insider || []).slice(0, 2).map((x, k) => (
          <p key={k} className="text-xl text-amber-200/80 pt-3">▲ Insider buy <b>{x.ticker}</b> · ${x.value} · {x.role}</p>
        ))}
      </Card>
      <Card className="col-span-2" accent={fcol} testid="tv-mood">
        {d.fng ? (
          <div className="flex items-center gap-[clamp(0.75rem,1.2vw,1.5rem)]" data-testid="tv-fng">
            <Ring value={d.fng.value} color={fcol} size={110} sub="F&G" />
            <div className="min-w-0"><p className="text-[clamp(1.25rem,2vw,2.25rem)] font-black" style={{ color: fcol, textShadow: `0 0 16px ${fcol}88` }}>{d.fng.label}</p><p className="text-[clamp(0.7rem,0.9vw,1.25rem)] text-cyan-100/50 nx-mono tracking-widest mt-1">CRYPTO SENTIMENT</p></div>
          </div>
        ) : <Empty>…</Empty>}
      </Card>
    </div>
  );
};
